import { PaymentType } from "@1games-ru/region-shared/dist/enums/payment/payment";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import toast from "@/domains/toasts/helpers/toast";

export default function useRoomFee(estateId: number, amount: number, onSuccess?: () => void) {
  const { t } = useTranslation("hotel");
  const [isFeePending, setIsFeePending] = useState(false);

  const cashPay = useCallback(async () => {
    try {
      if (estateId && amount) {
        setIsFeePending(true);
        const response = await EstateMpProvider.feePay(estateId, amount, PaymentType.Cash);
        if (response instanceof RpcMpProviderSuccessResponse) {
          toast.success(t("hotel.toast.paymentSuccess"));
          onSuccess?.();
        } else {
          console.log("fee pay error:", response);
          toast.error(t("hotel.toast.paymentError"));
        }
      }
    } catch (e) {
      console.log(e);
      toast.error(t("hotel.toast.paymentSystemError"));
    } finally {
      setIsFeePending(false);
    }
  }, [amount, estateId, onSuccess, t]);

  const cardPay = useCallback(async () => {
    try {
      if (estateId && amount) {
        setIsFeePending(true);
        const response = await EstateMpProvider.feePay(estateId, amount, PaymentType.Card);
        if (response instanceof RpcMpProviderSuccessResponse) {
          toast.success(t("hotel.toast.paymentSuccess"));
          onSuccess?.();
        } else {
          console.log("fee pay error:", response);
          toast.error(t("hotel.toast.paymentError"));
        }
      }
    } catch (e) {
      console.log(e);
      toast.error(t("hotel.toast.paymentSystemError"));
    } finally {
      setIsFeePending(false);
    }
  }, [amount, estateId, onSuccess, t]);

  return {
    isFeePending,
    cashPay,
    cardPay,
  };
}
